import * as metaStateUtils from '../../../../store/util/metaStateUtils';

import {configConstants} from '../../Config';
import {saveContentDepartmentsReducer} from './saveContentDepartmentsReducer';


const INITIAL_STATE = metaStateUtils.withDefaultMetaState({
    departments: []
});


export default (state = INITIAL_STATE, action) => {

    switch (action.type) {

        case configConstants.ACTION_GLOBAL_CONFIG_LOADED:

            return saveContentDepartmentsReducer(state, action.payload);


        default:

            return state;
    }
};
